import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud_off"}/>
}
